import React, { Suspense, useRef, useState } from 'react'
import emailjs from '@emailjs/browser';
import { Canvas } from '@react-three/fiber';
import Mail from '../models/Mail';
import Loader from '../components/Loader';
import useAlert from '../hooks/useAlert';
import Alert from '../components/Alert';

const Contact = () => {
  const formRef = useRef(null);
  const [form, setForm] = useState({name: '', email: '', message: ''});
  const [isLoading, setIsLoading] = useState(false);
  const [currentAnimation, setCurrentAnimation] = useState('idle');
  const [alert, showAlert, hideAlert] = useAlert();

  const handleChange = (e) => {
    setForm({...form, [e.target.name]: e.target.value});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setCurrentAnimation('sprint');

    emailjs.send(
      import.meta.env.VITE_APP_EMAILJS_SERVICE_ID, 
      import.meta.env.VITE_APP_EMAILJS_TEMPLATE_ID, 
      //process.env.VITE_APP_EMAILJS_SERVICE_ID,
      //process.env.VITE_APP_EMAILJS_TEMPLATE_ID,
      {
        from_name: form.name,
        to_name: "Nicolas",
        from_email: form.email,
        to_email: "nicolas.jacob@toulouse.miage.fr",
        message: form.message
      },
      //process.env.VITE_APP_EMAILJS_PUBLIC_KEY
      import.meta.env.VITE_APP_EMAILJS_PUBLIC_KEY
    ).then(() => {
      setIsLoading(false);
      showAlert({show: true, text: 'Message sent successfully!', type: 'success'})
      // console.log(import.meta.env.VITE_APP_EMAILJS_PUBLIC_KEY)
      
      setTimeout(() => { 
        hideAlert();
        setCurrentAnimation('idle');
        setForm({name: '', email: '', message: ''});
      }, 5000);
    }).catch((error) => {
      setIsLoading(false);
      setCurrentAnimation('idle');
      console.log(error); 
      showAlert({show: true, text: 'I didn\'t receive your message', type: 'danger'})
      // console.log(import.meta.env.VITE_APP_EMAILJS_PUBLIC_KEY)
    });
  };

  const handleFocus = (e) => setCurrentAnimation('walk');

  const handleBlur = () => setCurrentAnimation('idle');

  return (
    <section className="relative flex lg:flex-row flex-col max-container xl:h-[100vh]">   
      {alert.show && <Alert {...alert}/>}
      
      <div className="flex-1 min-w-[50%] flex flex-col">
        <h1 className="head-text">Get in Touch ☎️</h1>

        <br></br>
        <label className="text-black-500 font-semibold">
          Phone : <span className="blue-gradient_text font-semibold drop-shadow">+33 6 51 15 32 66 </span>
        </label>
        <label className="text-black-500 font-semibold">
          LinkedIn : <a href="https://www.linkedin.com/in/nicolas-jacob-peres-a7ba75196/" target="_blank" rel="noreferrer"><span className="blue-gradient_text font-semibold drop-shadow">Nicolas Jacob Peres</span></a>
        </label>

        <form className="w-full flex flex-col gap-7 mt-6" onSubmit={handleSubmit}>
          <label className="text-black-500 font-semibold">Name
            <input type="text" name="name" className="input"
              placeholder="Nicolas" required value={form.name} 
              onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur}
            />
          </label>

          <label className="text-black-500 font-semibold">Email
            <input type="email" name="email" className="input"
              placeholder="nicolas.jacob@toulouse.miage.fr" required value={form.email} 
              onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur}
            />
          </label>

          <label className="text-black-500 font-semibold">Your message
            <textarea name="message" className="textarea" rows={4}
              placeholder="Let me know how I can help you!" required value={form.message} 
              onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} 
            />
          </label>

          <button type="submit" className="btn" onFocus={handleFocus} 
            onBlur={handleBlur} disabled={isLoading}
          >
            {isLoading ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>
      <div className='lg:w-1/2 w-full lg:h-auto md:h-[550px] h-[350px]'>
        <Canvas 
          camera={{
            position: [0, 0, 5],
            fov: 75,
            near: 0.1,
            far: 1000
          }}
        >
          <directionalLight position={[0, 0, 1]} intensity={2.5}/>
          <ambientLight intensity={0.5}/>
          <Suspense fallback={<Loader/>}>
            <Mail
              currentAnimation={currentAnimation}
              position={[0.5, 0.35, 0]}
              scale={[0.5, 0.5, 0.5]}
              rotation={[12.6, -0.6, 0]}
            />
          </Suspense>
        </Canvas>
      </div>
    </section>
  )
}

export default Contact